import React, { useState } from 'react'
import BEMHelper from '@ynap/bem-helper'
import { Button } from '@ynap/button'
import { Portal } from 'react-portal'
import Overlay, { StopPropagation } from '@ynap/overlay'
import PromotionForm, { PromotionCheck } from '../promotion-form'
import { PromoCodesSectionProps, Promotion } from './types'

const bem = new BEMHelper('PromoCodesSection')

const PromoCodesSection = ({
    addPromotion,
    removePromotion,
    promotions,
    activePromotions,
    promotionsCheckerInfo,
    fetchPromotions,
    checkPromotion,
    setCheckoutNotification,
    checkoutAnalytics,
    isCSR,
    config,
    messages,
}: PromoCodesSectionProps) => {
    const onSubmit = (values: Promotion): Promise<void> => {
        return addPromotion(values.code, checkoutAnalytics).then(() => {
            setCheckoutNotification('success', messages.notifications.promoCodeApplied(), { autoHideDelay: 5000, sticky: true })
        })
    }

    const onRemove = (code: string): Promise<void> => {
        return removePromotion(code, checkoutAnalytics).then(() => {
            setCheckoutNotification('info', messages.notifications.promoCodeRemoved(), { autoHideDelay: 5000, sticky: true })
        })
    }

    const [checkActivePromoOpen, setCheckActivePromoOpen] = useState(false)

    return (
        <section className={bem('wrapper')}>
            {isCSR && checkActivePromoOpen && (
                <Portal>
                    <Overlay
                        title={messages?.paymentCodes?.checkActivePromos?.()}
                        goBack={() => setCheckActivePromoOpen(false)}
                        handleBodyClick={() => setCheckActivePromoOpen(false)}
                        onClose={() => setCheckActivePromoOpen(false)}
                    >
                        <StopPropagation>
                            <PromotionCheck
                                messages={messages}
                                activePromotions={activePromotions}
                                promotionsCheckerInfo={promotionsCheckerInfo}
                                fetchPromotions={fetchPromotions}
                                checkPromotion={checkPromotion}
                            />
                        </StopPropagation>
                    </Overlay>
                </Portal>
            )}

            <h3 className={bem('title')}>{messages.promotionForm.title()}</h3>
            <PromotionForm
                onSubmit={onSubmit}
                messages={messages}
                config={{ head: config }}
                onCheckActivePromo={() => setCheckActivePromoOpen(true)}
                isCSR={isCSR}
            />
            {promotions?.map((promo) => (
                <ul key={promo.code}>
                    <li className={bem('promotion')}>
                        <span>{promo.code}</span>
                        <Button className={bem('removeBtn')} aria-label={messages.totals.removeButtonLabel()} onClick={() => onRemove(promo.code)}>
                            {messages.totals.remove && messages.totals.remove()}
                        </Button>
                    </li>
                </ul>
            ))}
        </section>
    )
}

export default PromoCodesSection
